import type { ReactElement } from "react"
import type { ImageProps } from "@ionos-web-design-system/react"
import { Picture } from "@ionos-web-design-system/react"
import assetsSquidexToImageObject from "~/lib/assetsSquidexToImageObject"
import isEmpty from "~/lib/isEmpty"
import type { FetchPriority } from "~/types/mediaTypes"
import type { ResponsiveImages } from "~/types/squidex"

type Props = {
  images: ResponsiveImages
  fetchPriority?: FetchPriority
  className?: string
}
function ResponsiveImage({
  images,
  fetchPriority,
  className,
}: Props): ReactElement<ImageProps> {
  const largeImageObject: ImageProps = assetsSquidexToImageObject(
    images.large,
    ""
  )

  const mediumImageObject: ImageProps | undefined = !isEmpty(images.medium)
    ? assetsSquidexToImageObject(images.medium, "")
    : undefined

  const smallImageObject: ImageProps | undefined = !isEmpty(images.small)
    ? assetsSquidexToImageObject(images.small, "")
    : undefined

  return (
    <Picture
      srcData={{
        small: smallImageObject,
        medium: mediumImageObject,
        large: largeImageObject,
      }}
      className={className}
      // Picture's PictureProps does not expose fetchPriority, but the component spreads
      // ...restProps onto the underlying img element. The lowercase fetchpriority form is
      // required to avoid a TS error. Remove once @onestore/hel adds fetchPriority to PictureProps.
      {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
    />
  )
}

export default ResponsiveImage
